import React from "react";
import {Button, Divider, Grid, Header, Icon} from "semantic-ui-react";

class Project extends React.Component {

    componentDidMount() {
        this.props.scrollToStep(5);
    }

    render() {
        return (
            <div id={'project'} className={'step-section'}>
                    <Grid columns={1} stackable textAlign='center'>
                        <Grid.Row verticalAlign='middle'>
                            <Grid.Column>
                                <Header icon>
                                    <Icon name='settings' />
                                    My Project
                                </Header>
                                <Button onClick={() =>{this.props.setNextStep(6);this.props.changeStep();}} primary>Done</Button>
                            </Grid.Column>
                        </Grid.Row>
                    </Grid>
            </div>
        )
    }
}

export default Project;